import { baixarArquivo } from '../gestao/csv'
import { dataDoPrazo, dataHora, hojeISO, Resumo, rotuloPrioridade, rotuloStatus, rotuloTipo } from './comum'

const CABECALHO = [
  'Nº', 'Título', 'Tipo', 'Status', 'Prioridade', 'Esforço', 'Prazo', 'Bloqueada', 'Motivo do bloqueio',
  'Solicitante', 'Responsável', 'Aberta em', 'Atualizada em'
]

/** Uma célula do CSV. Aspas quando precisa e, na frente de texto que o Excel leria como fórmula, um apóstrofo. */
export function celula(valor: string | number | null | undefined): string {
  let t = valor == null ? '' : String(valor)
  if (/^[=+\-@\t\r]/.test(t)) t = `'${t}`
  return /[";\r\n]/.test(t) ? `"${t.replace(/"/g, '""')}"` : t
}

/**
 * A planilha da lista que está na tela (já filtrada). É um CSV com ponto e vírgula e acentos em UTF-8, que o Excel em
 * português abre direto com um duplo clique.
 */
export function planilhaDasSolicitacoes(lista: Resumo[]): string {
  const linhas = lista.map(s => [
    s.id, s.titulo, rotuloTipo(s.tipo), rotuloStatus(s.status), rotuloPrioridade(s.prioridade), s.esforco || '',
    dataDoPrazo(s.prazo), s.bloqueado ? 'Sim' : 'Não', s.bloqueioMotivo || '',
    s.solicitanteNome || '', s.responsavelNome || '', dataHora(s.criadoEm), dataHora(s.atualizadoEm)
  ])
  return [CABECALHO, ...linhas].map(l => l.map(celula).join(';')).join('\r\n') + '\r\n'
}

export const nomeDaPlanilha = (hoje: string = hojeISO()) => `solicitacoes-${hoje}.csv`

export const exportarSolicitacoes = (lista: Resumo[]) => baixarArquivo(nomeDaPlanilha(), planilhaDasSolicitacoes(lista))
